import Icon from '@/components/Icon'
import { numberWithCommas } from '@/util/numberHelpers'
import { pluralize } from '@/util/stringHelpers'
import { SelectionToolbar } from './SelectionToolbar'
import { useLayoutData } from '@/contexts/layout'
import { UserAssets } from '@/api/resources/user/assets/get/schema'
import { UserAsset } from '@/api/resources/user/asset/get/schema'
import useUpdateInventoryQuery from '@/hooks/useUpdateInventoryQuery'
import { SEARCH_PARAMS } from '@/constants/searchParams'
import { showModal } from '@/components/Modals/ModalV2'
import { MODAL_ID } from '@/constants/modalId'
import { isTransferable } from '@/util/assetHelpers'

export const ConvertToolbar = ({
  selectionLimit,
  loadedAssets
}: {
  selectionLimit: number
  loadedAssets: UserAssets
}) => {
  const filteredLoadedAssets = loadedAssets
    .filter(isTransferable)
    .filter((_, i) => i < selectionLimit)

  const { selectedAssets, updateSelectedAssets } = useLayoutData()
  const { update } = useUpdateInventoryQuery()

  const handleSelectAll = () => {
    updateSelectedAssets(filteredLoadedAssets)
  }

  const handleOnCancel = () => {
    update({
      type: 'reset',
      parameters: [SEARCH_PARAMS.ASSET_SELECTION_MODE]
    })
    updateSelectedAssets([])
  }

  const points =
    selectedAssets?.convert?.reduce((result: number, asset: UserAsset) => {
      return asset.points + result
    }, 0) || 0

  const selectableCount = filteredLoadedAssets.length

  return (
    <SelectionToolbar
      className="border-1 border-arcadeGreen shadow-arcade-sm"
      bgImage={{
        path: 'pages/inventory/',
        id: 'convertToolbarBg'
      }}
      value={{
        label: 'Point',
        pluralValue: points,
        component: (
          <div className="flex gap-[6px] items-center">
            <Icon name="arcade" className="w-3 h-3" />
            <div>
              <span className="text-arcadeGreen pricing-xl tabular-nums">
                {numberWithCommas(points)}
              </span>{' '}
              <span className="body-sm text-gray-300">
                {pluralize('PT', points)}
              </span>
            </div>
          </div>
        )
      }}
      primaryAction={{
        label: 'Convert',
        theme: 'green-arcade',
        disabled: !selectedAssets.convert.length,
        onClick: () =>
          showModal(MODAL_ID.arcade.convert, {
            assets: selectedAssets.convert,
            points
          })
      }}
      onCancel={handleOnCancel}
      onSelectAll={handleSelectAll}
      selectedCount={selectedAssets?.convert?.length}
      selectableCount={selectableCount}
    />
  )
}
